export default __webpack_public_path__ + "static/media/pipelines-icon.551d1c0c.svg";